<template>
  <view class="theme-{{ themeType }} them-container">
    <slot></slot>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { useTheme } from '../../common/theme'

createComponent({
  setup() {
    const { themeType } = useTheme()
    return {
      themeType
    }
  }
})
</script>

<style lang="stylus">
@require '../../themes/driver-variables.styl'
@require '../../themes/passenger-variables.styl'

.them-container
  height: 100%

</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true
  }
</script>
